import { Injectable } from '@angular/core';

/**
 * Maps stable help target_key values to live DOM elements (via {@link HelpTargetDirective}).
 */
@Injectable({
  providedIn: 'root',
})
export class HelpTargetRegistryService {
  private readonly targets = new Map<string, HTMLElement>();

  register(targetKey: string, el: HTMLElement): void {
    if (!targetKey) {
      return;
    }
    this.targets.set(targetKey, el);
  }

  unregister(targetKey: string): void {
    if (!targetKey) {
      return;
    }
    this.targets.delete(targetKey);
  }

  get(targetKey: string): HTMLElement | null {
    return this.targets.get(targetKey) ?? null;
  }

  clear(): void {
    this.targets.clear();
  }
}
